import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpUtil } from '../../utils/http-util';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AccountModel } from '../../models/account';
import { OptionConfigurationModel } from '../../models/option-configuration';
import { EnumType } from '../../models/enums/enum';
import { StorageUtil } from '../../utils/storage-util';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    private _isLoggedId: boolean;
    private _accountModel: AccountModel;
    private _option_configuration: OptionConfigurationModel;

    constructor(
        private http: HttpClient,
        private router: Router
    ) {
    }

    login(username: string, password: string, senderId: string): Observable<any> {
        const headerParams = {
            'sender-id': senderId
        };
        const payload = {
            'username': username,
            'password': password,
            'platform': 'Web'
        };
        const body = JSON.stringify(payload);
        const url = environment.base_url + '/v1.0.0/auth/';
        return this.http.post(url, body, HttpUtil.getHttpOptions(headerParams)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
    }

    logout() {
        const url = environment.base_url + '/v1.0.0/auth/logout';
        return this.http.post(url, null, HttpUtil.getHttpOptionsWithTokenV2(EnumType.ContentType.JSON)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
    }

    get isLoggedIn() {
        return this._isLoggedId;
    }

    set isLoggedIn(flag) {
        this._isLoggedId = flag;
    }

    getAccountModel() {
        return this._accountModel;
    }

    setOptionConfiguration(optionConfiguratio: OptionConfigurationModel) {
        this._option_configuration = optionConfiguratio;
    }

    getOptionConfiguration() {
        return this._option_configuration;
    }

    setAccountModel(accountModel: AccountModel) {
        this._accountModel = Object.assign(new AccountModel(), accountModel);
        //this._accountModel.getSelectedRoleByHierarchy();
    }

    isTokenAlive(token: string): Observable<any> {
        const params = {
            'x-access-token': token
        };
        const url = environment.base_url + '/v1.0.0/auth/token-alive';
        // console.log('Invoking token alive to: ' + url);
        // console.log('Invoking token alive token: ' + token);
        let result = this.http.post(url, null, HttpUtil.getHttpOptionsWithTokenV2(EnumType.ContentType.JSON, null, params)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
        return result;
    }

    redirectLogin() {
        let company = StorageUtil.getCompany(EnumType.LocalStorage.COMPANY, environment.storage_encrypt_flag);
        if (company) {
            StorageUtil.remove(EnumType.LocalStorage.COMPANY);
            this.router.navigate(['/auth/Login'], { queryParams: { 'c': company.name } });
        } else {
            this.router.navigate(['/auth/Login']);
        }
    }

    getServiceModel() {
        const url = environment.base_url + '/v1.0.0/auth/';
        return this.http.get(url, HttpUtil.getHttpOptionsWithTokenV2(EnumType.ContentType.JSON)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
    }

    /**
     * Verify access by role
     * @param nextUrl Route to verify
     */
    verifyAccessRole(nextUrl: string) {
        let params = {
            route: nextUrl
        }
        const url = environment.base_url + '/v1.0.0/auth/verify-access';
        return this.http.get(url, HttpUtil.getHttpOptionsWithTokenV2(EnumType.ContentType.JSON, null, params)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
    }

    updateOptionConfiguration(code: string, html_id: string, visible: boolean) {
        let bodyObject = {
            html_id: html_id,
            visible: visible
        }
        const url = environment.base_url + '/v1.0.0/auth/option-configuration/' + code;
        let body = JSON.stringify(bodyObject);
        return this.http.put(url, body, HttpUtil.getHttpOptionsWithTokenV2(EnumType.ContentType.JSON)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
    }
}
